<template>
  <div class="popup-wrapper sifrarnik">
    <DataLoader :is_on="updating" />
    <div class="sifrarnik-radnje-title"><span>{{ $t("forms.cost_sheet.sifarnik_popup.title") }}</span>
      <a @click="closePopup()" class="popup-close-icon-wrapper"><img src="@/assets/img/entry_form_close.svg" /></a>
    </div>
    <div class="radnje-content">
      <div class="radnje-main-wrapper">
        <div class="main-sub-wrapper" v-for="(tbr, key) in radnje" :key="key">
          <single-sifra-tarife :sifra="tbr" :depth="0" @tmpadd="addToList" @tmpremove="removeFromList" @show_details="showDetails" :radnje="radnje_list" />
        </div>
      </div>
    </div>
    <div class="chosen-radnje">
      <span>
        <b>{{ $t("forms.cost_sheet.sifarnik_popup.chosen_radnje_lbl") }}</b> 
        <span v-if="radnje_list.length>0">{{ $t("forms.cost_sheet.sifarnik_popup.tbr") }}{{ radnje_list.map((r)=>r.number).join(', ') }}</span>
        <span v-else>{{ $t("forms.cost_sheet.sifarnik_popup.none") }}</span>
      </span>
    </div>
    <!-- </div> -->
    <div :style="chosen_element == null ? 'color:grey;' : ''" class="add-radnja" @click=" chosen_element != null ? closePopup() : ''">
      {{ $t("forms.cost_sheet.sifarnik_popup.btn") }}
    </div>
    <v-dialog v-model="custom_dialog" persistent width="675px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{ $t("forms.cost_sheet.sifarnik_popup.err") }}
        </div>
        <div class="tbr-description">
          <div class="folder-open-name">
            {{ $t("forms.cost_sheet.sifarnik_popup.path") }}
            <span v-for="(bred, key) in this.custom_breadcrumbs" :key="key">
              <span class="clickable-breadcrumb" :class="{ 'active': bred.uid == tarifni_info.uid }"
                @click="breadcrumbsViewPushback(key)">{{ bred.name.trim() }}</span>
              <span style="color:#1976d2">&nbsp;/ </span>
            </span>
          </div>
        </div>

        <div class="tbr-description">
          <div v-if="tarifni_info.references != undefined">
            <div class="description-text" v-if="tarifni_info.references.length > 0">
              {{ $t("forms.cost_sheet.sifarnik_popup.ref") }}<br />
              <div v-for="(single_ref, key) in tarifni_info.references" :key="key" class="case-info-item-info"
                @click="addToRefference(single_ref)">
                <a>{{ referenceName(single_ref) }}</a>
              </div>
            </div>
          </div>

          <div
            v-html="tarifni_info.description != '' && tarifni_info.description != null ? tarifni_info.description : 'Nema opisa'"
            class="description-text"></div>
          <!-- <div > <input type="number" v-model="custom_bodovi"></div> -->
          <v-text-field label="Broj bodova" hint="1 bod = 2.00 EUR" v-model="custom_bodovi" regular type="number" />
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div class="universal-vdialog-button vbutton-secondary"
            @click="cancelInsert()">
            {{ $t("repetitive.cancel") }} </div>
          <div class="universal-vdialog-button vbutton-primary" @click="saveCustom()"> {{ $t("forms.cost_sheet.sifarnik_popup.btn") }} </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="custom_dialog_details" width="675px" style="min-height:675px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          <i>{{ tarifni_info.name }}</i>
        </div>
        <div class="tbr-description">
          <div class="folder-open-name">
            {{ $t("forms.cost_sheet.sifarnik_popup.path") }}
            <span v-for="(bred, key) in this.custom_breadcrumbs" :key="key">
              <span class="clickable-breadcrumb" :class="{ 'active': bred.uid == tarifni_info.uid }"
                @click="breadcrumbsViewPushback(key)">{{ bred.name.trim() }}</span>
              <span style="color:#1976d2">&nbsp;/ </span>
            </span>
          </div>
        </div>

        <div class="tbr-description" v-if="tarifni_info.references != undefined">
          <div class="description-text" v-if="tarifni_info.references.length > 0">
            {{ $t("forms.cost_sheet.sifarnik_popup.ref") }}<br />
            <div v-for="(single_ref, key) in tarifni_info.references" :key="key" class="case-info-item-info"
              @click="addToRefference(single_ref)">
              <a>{{ referenceName(single_ref) }}</a>
            </div>
          </div>
          <div
            v-html="tarifni_info.description != '' && tarifni_info.description != null ? tarifni_info.description : 'Nema opisa'"
            class="description-text"></div>
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div class="universal-vdialog-button vbutton-secondary" @click="custom_dialog_details = false"> {{ $t("forms.cost_sheet.sifarnik_popup.close") }} </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
  <!-- end popup wrapper -->
</template>

<script>
import $ from "jquery";
import gsap from "gsap";
import DataLoader from '@/components/generalComponents/DataLoader'
import SingleSifraTarife from "@/components/costSheetComponents/sifarnik/SingleSifraTarife.vue";

export default {
  props: ['radnje', "chosen_row", "flat_radnje"],
  data() {
    return {
      accessToken: "",
      updating: false,
      listToReturn: [],
      chosen_element: null,
      custom_dialog: false,
      custom_bodovi: 0,
      tarifni_info: { name: '', description: '' },
      custom_dialog_details: false,
      custom_breadcrumbs: [],
      radnje_list:[],
    }
  },
  components: {
    DataLoader,
    SingleSifraTarife
  },
  methods: {
    referenceName(ref_uid) {
      return this.flat_radnje.find(element => element.uid == ref_uid).name;
    },
    addToRefference(ref_uid) {
      let ref_tmp = this.flat_radnje.find(element => element.uid == ref_uid);
      console.log(ref_tmp);
      this.tarifni_info = ref_tmp;
      this.custom_breadcrumbs.push({
        name: this.tarifni_info.name,
        uid: this.tarifni_info.uid
      })

    },
    breadcrumbsViewPushback(indexCut) {
      this.tarifni_info = this.flat_radnje.find(element => element.uid == this.custom_breadcrumbs[indexCut].uid);
      if (this.custom_breadcrumbs.length > 1) {
        this.custom_breadcrumbs = this.custom_breadcrumbs.slice(0, indexCut + 1);
      }
    },
    closePopup() {
      this.$emit('closePopup');
    },
    showDetails(info) {
      this.custom_breadcrumbs = [];
      this.tarifni_info = info;
      this.custom_breadcrumbs.push({
        name: this.tarifni_info.name,
        uid: this.tarifni_info.uid
      })
      this.custom_dialog_details = true;
    },
    setInitVals() {
      this.chosen_row.iznos = 0;
      this.custom_bodovi = 0;
    },
    addToList(sub) {
      // this.setInitVals();
      this.custom_breadcrumbs = [];
      if (sub != null) {
        this.chosen_element = sub;
        this.tarifni_info = sub;
        this.custom_breadcrumbs.push({
          name: this.tarifni_info.name,
          uid: this.tarifni_info.uid
        })
        if (sub.value > 0) {
          const tarif = {
            number: this.chosen_element.number,
            name: this.chosen_element.name,
            uid: this.chosen_element.uid,
            value: this.chosen_element.value
          }
          this.radnje_list.push(tarif);
          this.calculateState();
        }
        else {
          this.custom_dialog = true;
        }
      }
      else{
        this.cancelInsert();
      }
    },
    removeFromList(sub){
      this.radnje_list = this.radnje_list.filter((r)=>r.uid != sub.uid);
      this.calculateState();
    },
    saveCustom() {
      const tarif = {
          number: this.chosen_element.number,
          name: this.chosen_element.name,
          uid: this.chosen_element.uid,
          value: Number(this.custom_bodovi)
        }
      this.radnje_list.push(tarif);
      this.custom_dialog = false;
      this.calculateState();
    },
    calculateState() {
      this.chosen_row.iznos = (this.radnje_list.reduce(function (prev,next) {return prev+=Number(next.value)},0)*2.00).toFixed(2);
      this.chosen_row.tbrovi = this.radnje_list.map((r)=>r.number).join(', ');
      this.chosen_row.tbrovi = this.chosen_row.tbrovi.length>0 ? this.chosen_row.tbrovi+' OT' : this.chosen_row.tbrovi;
      this.chosen_row.opis = this.radnje_list.length ? this.radnje_list[0].name : "";
    },
    cancelInsert(){
      this.chosen_element= null;
      this.tarifni_info= { name: '', description: '' };
      this.chosen_row.tbrovi='';
      this.chosen_row.opis='';
      this.custom_dialog = false;
      $('.popup-check.active').removeClass('active');
    },
    showSubtree(e) {
      $(e.target).closest('.radnja-tbr-main-wrapper').next('.sub-tbr').toggleClass('act');
    }
  },
  created() {
  },
  mounted() {
    this.calculateState();
    //close anim
    gsap.to(".mainH", 0.5, { overflow: "hidden" });
    gsap.to(".entry-troskovnik", 0.5, {
      filter: "blur(5px)",
      opacity: 0.2,
      pointerEvents: "none"
    });
    gsap.fromTo(
      ".popup-wrapper",
      0.5,
      { opacity: 0 },
      { zIndex: "999", opacity: 1 }
    );
    $(".popup-close-icon-wrapper").hover(
      function () {
        gsap.to($(this).find("img"), 0.3, {
          rotation: 180,
          transformOrigin: "center",
        });
      },
      function () {
        gsap.to($(this).find("img"), 0.5, {
          rotation: -180,
          transformOrigin: "center",
        });
      }
    );
  },
  destroyed() {
    $(".popup-close-icon-wrapper").off();
  },
};
</script>

<style>

</style>